import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import {EMPTY, Observable, of} from 'rxjs';
import {Store} from '@softline/core';
import {catchError, map, take, tap} from 'rxjs/operators';
import {SOFTLINE_FEATURE_PRODUCT_SCAN} from '../product-scan.shared';
import {ProductStore} from '../store/product.store';

@Injectable()
export class EntityGuard  {

  constructor(private store: Store, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.checkEntity().pipe(catchError(() => EMPTY));
  }

  private checkEntity(): Observable<boolean> {
    return this.store.observe(SOFTLINE_FEATURE_PRODUCT_SCAN, ProductStore.getters.data).pipe(
      map(entity => entity !== null),
      tap(async entityLoaded => {
        if (entityLoaded) { return; }
        await this.router.navigate(['/artikelinfo']);
      }),
      take(1)
    );
  }
}
